import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: false,

        backend: {
            loadPath: `./{{lng}}.json?dc=${uuidv4()}`
        },
    });

export default i18n;
